import React from 'react';
import screenfull from 'screenfull';
import {
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Button, Progress,
    Nav, NavItem, NavLink,Dropdown,
     ButtonDropdown, 
} from 'reactstrap';
import {nombre_empresa} from '../../../actions/_request';
import { TabContent, TabPane, Row, Col } from 'reactstrap';
import swal from 'sweetalert2';
import ModalTablas from '../../../components/catalogos/modal_tablas';
import ModalPlazos from '../../../components/plazosvencimientos/modal';
import ModalParametros from '../../../components/parametrossistema/modal';
import ModalDatosFactura from '../../../components/datosfactura/modal';

// icons
import IconNotification from 'react-icons/lib/md/notifications-none';
import IconFullScreen from 'react-icons/lib/md/crop-free';
import IconMail from 'react-icons/lib/md/mail';
import IconLogout from 'react-icons/lib/md/power-settings-new';
import IconDownload from 'react-icons/lib/md/cloud-download';
import IconCake from 'react-icons/lib/md/cake';
import IconMenu from 'react-icons/lib/md/menu';
import IconSetting from 'react-icons/lib/fa/cog';

// style
import './style.css';
import profile from  './profile.jpg';
import logo from  '../nav/logo.png';
import division from  './MENU-REDBLACK.png';


import IconoFactura from '../../../images/icons_factura.svg';
import IconoTicket from '../../../images/icons_ticket.svg';

import IconoCotizacion from '../../../images/icons_cotizacion.svg';
import IconoUnidades from '../../../images/MENU_UNIDADES.svg';
import IconoCatalogos from '../../../images/MENU_CATALOGOS.svg';
import IconoMovimientos from '../../../images/MENU_MOVIMIENTOS.svg';
import IconoParametros from '../../../images/MENU_PARAMETROS.svg';

import IconoProductos from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';
import IconoCategorias from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';
import IconoFolios from '../../../images/ICONS/ICONS_FOLIOS DOCUMENTOS.svg';
import IconoEmbarques from '../../../images/ICONS/ICONS_VIAS DE EMBARQUE.svg';
import IconoLAB from '../../../images/ICONS/ICONS_CONCEPTO LAB.svg';
import IconoImpuestos from '../../../images/ICONS/ICONS_IMPUESTOS.svg';
import IconoDescuentos from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';

import IconoAlmacenes from '../../../images/ICONS/ICONS_ALMACENES.svg';
import IconoLineas from '../../../images/ICONS/ICONS_LINEAS.svg';
import IconoMarcas from '../../../images/ICONS/ICONS_MARCAS.svg';
import IconoEstilos from '../../../images/ICONS/ICONS_ESTILOS.svg';
import IconoColores from '../../../images/ICONS/ICONS_COLORES Y SABORES.svg';
import IconoMedidas from '../../../images/ICONS/ICONS_MEDIDAS.svg';

import IconoConceptos from '../../../images/ICONS/ICONS_TIPOS DE CONCEPTOS.svg';
import IconoTerminos from '../../../images/ICONS/ICONS_TERMINOS DE PAGO.svg';
import IconoMovimientos2 from '../../../images/ICONS/ICONS_TIPOS DE MOVIMIENTOS.svg';


/*Falta */
import IconoInsidencia from '../../../images/icons_ticket.svg';
import IconoCompraEspecial from '../../../images/icons_ticket.svg';








import ReactSVG from 'react-svg';


const catalogos =[
         'Bancos',
         'Metodos de Pago',
         'Formas de Pago',
         'Codigos Postales',
         'Monedas',
         'Paises',
         'Impuestos',
         'Regimen Fiscal',
         'Usos de CFDI',
         'Tasas o Cuotas',
         'Unidades',
         'Relaciones',
         'Productos y Servicios',
         'Aduanas',
    ];



class Menu extends React.Component{

    constructor(props){
        super(props);


    this.state = {
      menu: 0,
      submenu:0,
      modal:false,
      titulo:'error',
      catalogo:0,
      modal_plazos:false,
      modal_parametros:false,
      modal_datos_facutra:false,
      activeTab:2,
    };

     this.toggle = this.toggle.bind(this);
     this.toggle_modal = this.toggle_modal.bind(this);
     this.toggle_plazos = this.toggle_plazos.bind(this);
     this.toggle_parametros = this.toggle_parametros.bind(this);
     this.toggle_datos_factura = this.toggle_datos_factura.bind(this);
     this.modulo = this.modulo.bind(this);
     this.permisos_modal = this.permisos_modal.bind(this);
  }
  permisos_modal(id){
    if(parseInt(this.props.user.rol)==4){
        if(id==1){
            this.setState({
                modal_datos_facutra : !this.state.modal_datos_facutra,
            })
        }
        if(id==2){
            this.setState({
                modal_parametros : !this.state.modal_parametros,
            })
        }
        if(id==3){
            this.setState({
                modal_plazos : !this.state.modal_plazos,
            })
        }

    }else{
          swal("Advertencia!", "No Tienes el Permiso para Esta Accion!", "error");
    }
    
  }
  permisos(id){
    let bandera=false
    // console.log('permisos----->',this.props.permisos)
    // console.log('modulo--->',id)
    switch (id) {
      default:
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
      break;
        
        case 99 :
            if(parseInt(this.props.user.rol)==4){
                bandera=true;
            }
        break;
    }
    return bandera;
  }
  modulo(url,id){
    let bandera=false;

    if(id==0){
        bandera=true;

    }else{
        bandera=this.permisos(id);

    }
    if(bandera)
        {
            this.props.props.history.push('/app'+url);
        }else{
             swal("Advertencia!", "No Tienes el Permiso para Esta Accion!", "error");
        }

  }
  nada(){}
    toggle_modal(index=0){  

        this.setState({
            modal : !this.state.modal,
            menu: 0,
            submenu:0,
            titulo:catalogos[index],
            catalogo:index,         
        })
    }
    toggle_plazos(){    

        this.setState({
            modal_plazos : !this.state.modal_plazos,
            menu: 0,
            submenu:0,      
        })
    }
    toggle_parametros(){    

        this.setState({
            modal_parametros : !this.state.modal_parametros,
            menu: 0,
            submenu:0,      
        })
    }
    toggle_datos_factura(){ 

        this.setState({
            modal_datos_facutra : !this.state.modal_datos_facutra,
            menu: 0,
            submenu:0,      
        })
    }

    toggle(menu,id) {
        let valor=0;

        if(menu===1){
            if(parseInt(this.state.menu)!==id)
            valor=id;
            this.setState({
              menu: valor
            });
        }else if(menu===2){
            if(parseInt(this.state.submenu)!==id)
            valor=id;
            this.setState({
              submenu: valor
            });

        }else if(menu ===4){
            if(parseInt(this.state.submenu)!==id)
            valor=id;
            this.setState({
              submenu: valor
            });
        }
    }
    
    toggleNavTab(tab) {

        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

  
    render(){
        // console.log('menu---->',this.state.menu);
         // console.log('tab---->',this.state.activeTab);
        return(
            <header className="site-head  container-fluid  ">

     <div className="row align-items-center  ">
     <div className=" col-6 col-lg-2 col-xl-2 seccion_empresa_menu " >
                 <div className="wrap profile menu_normal ">
                        <div className='lbl_nombre_empresa_menu'><b onClick={() => { this.modulo('',0);}} > {nombre_empresa}</b></div>
            </div>
            <div className="wrap mr-4 menu_responsivo ">
            <IconMenu size="24" color="#00000" onClick={this.props.toggleNav} style={{cursor: 'pointer', marginTop:'10px'}}/>
        </div>
     </div>

     <div className=" col-8 seccion_menu menu_normal" >
     <Nav className='pl-4 menu_principal' >
                  
                  <NavItem>
                   <Dropdown  nav isOpen={parseInt(this.state.menu)===2?true:false} toggle={() => {this.toggle(1,2);this.toggleNavTab(2);}} >
                    <DropdownToggle className=''  nav caret>
                        <ReactSVG className='contenedor_svg' src={IconoCatalogos}  beforeInjection={svg => { svg.classList.add('svg_menu');  }}/>
                        <div style={{position:'relative',display:'inline'}} > 
                        <label className={`${parseInt(this.state.activeTab)===2?'menu_activado':''}`}> Catalogos </label>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu>            
                        <DropdownItem onClick={() => { this.modulo('/facturacion/proveedores',3); }} >Provedores</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/clientes',2);}}> Clientes </DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/inventario',1);}}> Productos </DropdownItem>
                        <Dropdown className='letras_menu ajuste_menu' nav direction="right"   isOpen={parseInt(this.state.submenu)===3?true:false} toggle={() => {this.toggle(2,3);}}  >
                          <DropdownToggle   className="menu_derecha" nav caret>Catalogos</DropdownToggle>
                          <DropdownMenu  className='letras_menu' style={{ float: 'right', position: 'fixed',  top: '0' , left: '100%'}}>  
                            <DropdownItem onClick={() => {this.modulo('/facturacion/folios',0);}}>Folios de Documentos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/categorias',1);}}>Categorias</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/embarques',0);}}>Vias de Embarque</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/lab',0);}}>Conceptos LAB</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/impuestos',0);}}>Impuestos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/descuentos',0);}}>Descuentos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/almacenes',0);}}>Alamcenes</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/lineas',0);}}>Lineas</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/marcas',0);}}>Marcas</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/estilos',0);}}>Estilos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/coloressabores',0);}}>Colores/Sabores</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/medidas',0);}}>Medidas</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/tipos_movimientos',0);}}>Tipo de Movimientos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/tipos_conceptos',0);}}>Tipos de Conceptos</DropdownItem>
                            <DropdownItem onClick={() => {this.modulo('/facturacion/terminos_pago',0);}}>Terminos de Pago</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                        <Dropdown className='letras_menu ajuste_menu' nav direction="right"   isOpen={parseInt(this.state.submenu)===4?true:false} toggle={() => {this.toggle(2,4);}}  >
                            <DropdownToggle className="menu_derecha" nav caret>
                              CFDI 3.3
                            </DropdownToggle>
                            <DropdownMenu className='letras_menu' style={{  float: 'right', position: 'fixed',  top: '0' , left: '100%'}}>  

                                <DropdownItem onClick={() => {this.toggle_modal(0);}}>Bancos</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(1);}}>Métodos de Pago</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(2);}}>Formas de Pago</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(3);}}>Códigos Postales</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(4);}}>Monedas</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(5);}}>Países</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(6);}}>Impuestos</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(7);}}>Régimen Fiscal</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(8);}}>Usos de CFDI</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(9);}}>Tasas o Cuotas</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(10);}}>Unidades</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(11);}}>Relaciones</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(12);}}>Productos y Servicios</DropdownItem>
                                <DropdownItem onClick={() => {this.toggle_modal(13);}}>Aduanas</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                    </DropdownMenu>
                  </Dropdown>                  
                  </NavItem>
                  <NavItem>
                    <Dropdown nav isOpen={parseInt(this.state.menu)===3?true:false} toggle={() => {this.toggle(1,3);this.toggleNavTab(3);}} >
                    <DropdownToggle nav caret>
                    <ReactSVG className='contenedor_svg' src={IconoMovimientos}  beforeInjection={svg => { svg.classList.add('svg_menu');  }}/>
                        <div style={{position:'relative',display:'inline'}} > 
                     <label className={`${parseInt(this.state.activeTab)===3?'menu_activado':''}`}> Movimientos </label>
                     </div>
                    </DropdownToggle>
                    <DropdownMenu className='letras_menu'>
                    <DropdownItem onClick={() => { this.modulo('/cotizaciones',0);}} >Cotizaciones</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/invoiceModule',0);}} >Facturas</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/facturacion/C-A/Clientes',9);}} >C / A de Clientes</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/facturacion/movimientoscompras',8);}} >Compras</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/facturacion/C-A/Proveedores',10);}} >C / A de Proveedores</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/facturacion/movimientosAlmacenes',11);}} >Almacén</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>   
                  </NavItem>
                  <NavItem>
                    <Dropdown  nav isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle(1,1);this.toggleNavTab(1);}} >
                    <DropdownToggle className=''  nav caret>
                        <ReactSVG className='contenedor_svg' src={IconoTicket}  beforeInjection={svg => { svg.classList.add('svg_menu');  }}/>
                        <div style={{position:'relative',display:'inline'}} > 
                        <label className={`${parseInt(this.state.activeTab)<2?'menu_activado':''}`}> Tickets </label>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu>            
                        <DropdownItem onClick={() => { this.modulo('/tickets',0);}} >Tickets</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/insidencias',0);}} > Incidencias </DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/ComprasEspeciales',0);}}> Compras Especiales </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>  
                  </NavItem>
                  <NavItem>
                    <Dropdown  nav isOpen={parseInt(this.state.menu)===5?true:false} toggle={() => {this.toggle(1,5);this.toggleNavTab(5);}} >
                    <DropdownToggle className=''  nav caret>
                        <ReactSVG className='contenedor_svg' src={IconoUnidades}  beforeInjection={svg => { svg.classList.add('svg_menu');  }}/>
                        <div style={{position:'relative',display:'inline'}} > 
                        <label className={`${parseInt(this.state.activeTab)===5?'menu_activado':''}`}> Reportes </label>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu>            
                        <DropdownItem onClick={() => { this.modulo('',0);}} >Producción</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/eventos',0);}} > Eventos </DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/reportes',0);}}> Reportes </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>  
                  </NavItem>

                  <NavItem>
                   <Dropdown nav isOpen={parseInt(this.state.menu)===4?true:false} toggle={() => {this.toggle(1,4);this.toggleNavTab(4);}} >
                    <DropdownToggle nav caret>
                        <ReactSVG className='contenedor_svg' src={IconoParametros}  beforeInjection={svg => { svg.classList.add('svg_menu');  }}/>
                        <div style={{position:'relative',display:'inline'}} > 
                      <label className={`${parseInt(this.state.activeTab)===4?'menu_activado':''}`}>Parametros</label>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu className='letras_menu'>
                        <DropdownItem onClick={() => {this.permisos_modal(1);}}>Datos Factura E.</DropdownItem>
                        <DropdownItem onClick={() => {this.permisos_modal(2);}}>Parametros Especiales</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/usuarios',6);}}>Usuarios</DropdownItem>
                        <DropdownItem onClick={() => { this.modulo('/departamentos',6);}}>Departamentos</DropdownItem>
                        <DropdownItem onClick={() => {this.modulo('/descuentos',99);}}>Tipo Clientes</DropdownItem>
                        <DropdownItem onClick={() => {this.modulo('/facturacion/tipos_cambio',99);}}>Tipos de Cambios</DropdownItem>
                        <DropdownItem onClick={() => {this.permisos_modal(3);}}>Plazos Vencimientos</DropdownItem>                        
                    </DropdownMenu>
                  </Dropdown>                  
                  </NavItem>
                </Nav>

     </div>
     <div className=" col-6 col-lg-2 seccion_usuario_menu " >
                 <div className="wrap profile">
                <UncontrolledDropdown>
                    <DropdownToggle tag="div">
                        {/*<img src="http://i.imgur.com/0rVeh4A.jpg" alt="avatar"/>
                        <img src={profile} alt="user profile" />*/}
                        <div className='lbl_nombre_usuario_menu'><b> {this.props.user && this.props.user.name}</b></div>
                    </DropdownToggle>
                    <DropdownMenu right style={{minWidth: '12rem'}}>
                      {/*  <DropdownItem header>{this.props.user && this.props.user.name}</DropdownItem>
                        <DropdownItem divider/>*/}
                        <div className="text-right ml-3 mr-3 mt-2">
                            <Button block color="info" size="sm" onClick= {this.props.ChangePass}>
                                <IconSetting size="15"/>&emsp;Cambiar Contraseña
                            </Button>
                        </div>
                        <div className="text-right ml-3 mr-3 mt-2">
                            <Button block color="success" size="sm" onClick={this.props.onClick}>
                                <IconLogout size="15"/>&emsp;Logout
                            </Button>
                        </div>               
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
     </div>
     </div>

     <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.catalogo}
                    retorno={this.nada}
                />
                <ModalPlazos
                    open={this.state.modal_plazos}
                    toggle={this.toggle_plazos}                 
                />
                {this.state.modal_parametros&&
                <ModalParametros
                    open={this.state.modal_parametros}
                    toggle={this.toggle_parametros}                 
                />
                }
                {this.state.modal_datos_facutra&&
                <ModalDatosFactura
                    open={this.state.modal_datos_facutra}
                    toggle={this.toggle_datos_factura}                  
                />
                }

        
    </header>
           
          
                
                
           

            )
    }

}




export default Menu;



// WEBPACK FOOTER //
// ./src/shared/components/header/index.js